module.exports = __webpack_public_path__ + "static/devConnect-0ea216683ee2e81016c3b9fce8d7f296.png";